export const PROJECAO_LABEL = "Valor total";
export const PROJECAO_PENDENTE = "Projeção pendente";
